export default __webpack_public_path__ + "static/door6-0cbd8ceb43e341f6ad2f79d0cfeeb94d.jpg";